const radiansToDegrees = (radians: number): number => {
    return (radians * 180) / Math.PI;
};

export default radiansToDegrees;
